import get from 'lodash.get';
import reloadRequiredActionsTypes from '../constants/reload-required-action-types';

const isReloadSupposed = (action) => {
  const strategy = get(action, 'payload.options.strategy');

  return Boolean(strategy) || reloadRequiredActionsTypes.includes(action.type);
};

export default isReloadSupposed;
